<kendo-stacklayout gap="30" orientation="horizontal" style="height:100%">
  <img #backgroundImage style="display:none" />
  @if(showResetPasswordScreen)
  {
    <div class="background">
      <div class="container">
        <kendo-card class="i-card">
          <form [formGroup]="resetPasswordForm" (ngSubmit)="onSubmit()">
            <div class="header">
              <img class="headerImg" src="../../../../assets/images/epclogo.png" />
              <h3 class="headerText">EPC Redeployment Password Reset</h3>
            </div>
            <div class="card-body">
              @if(submitted && resetPasswordFormErrorMessage != undefined){
                <div>
                  <span class="password-reset-validation">{{resetPasswordFormErrorMessage}}</span>
                </div>
              }
              <div class="form-row">
                <div class="form-group col">
                  <label>Password</label>
                  <kendo-textbox class="form-textbox" type="password" formControlName="password"></kendo-textbox>
                  @if(submitted && f['password'].errors){
                  <div class="k-tooltip-validation">
                    @if(f['password'].errors['required']){
                    <div class="validationMsg">Password is required</div>
                    }
                  </div>
                  }

                </div>
              </div>
              <div class="form-row">
                <div class="form-group col">
                  <label>Confirm Password</label>
                  <input class="form-textbox" kendoTextBox type="password" formControlName="confirmPassword" />
                  @if(submitted && f['confirmPassword'].errors){
                  <div class="k-tooltip-validation">
                    @if(f['confirmPassword'].errors['required']){
                      <div class="validationMsg">Confirm Password is required</div>
                    }
                  </div>
                  }
                </div>
              </div>
            </div>
            <div class="card-footer">
              <button kendoButton type="submit" class="primary btnReset">
                Reset
              </button>
            </div>
          </form>
        </kendo-card>
      </div>
    </div>
  }
</kendo-stacklayout>
